import Glob from './global';

class Header{
    constructor(){
        const self = this;
        this.glob = new Glob();
        this.informaiton = document.querySelector('.information');
        this.header = document.querySelector('.header');
        this.icon_search = this.header.querySelector('.header__icons__search');
        this.icon_mini_cart = this.header.querySelector('.header__icons__mincart');
        this.mobile_hamburger = this.header.querySelector('.header__hamburger');
        this.btn_cart = this.header.querySelector('.header__icons__mincart');
        this.mini_cart = this.header.querySelector('.mini-cart');
        if(this.informaiton) this.boxInformation(this.informaiton);
        if(this.icon_search) this.showSearch(this.icon_search);
        if(this.icon_mini_cart) this.showCart(this.icon_mini_cart);
        if(this.mobile_hamburger) this.showNav(this.mobile_hamburger);

        const origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
            if (url === '/victoriab2c/?wc-ajax=remove_from_cart' || url == '/victoriab2c/?wc-ajax=get_refreshed_fragments') {
                this.addEventListener('load', () => {
                    self.countMiniCart();
                });
            } else {
            }
            origOpen.apply(this, arguments);
        };

        if (window.innerWidth < 767) {
            setInterval(() => {
                if (this.mini_cart.querySelector('.cart_list'))
                    this.mini_cart.querySelector('.cart_list').style.height = `calc(${window.innerHeight}px - 220px)`;
            }, 100)
        }

    }


    countMiniCart() {
        const http = new XMLHttpRequest(),
            url = AJAXURL,
            data = {
                action: 'count_mini_cart'
            },
            params = this.converObc(data);
        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        http.onreadystatechange = () => {
            if (http.readyState == 4 && http.status == 200) {
                if (Number(http.response) > 0) {
                    if (this.btn_cart.querySelector('.header__min-cart__count')) {
                        this.btn_cart.querySelector('.header__min-cart__count').innerText = http.response;
                    }else{
                        let span = document.querySelector('span');
                        span.classList.add('header__min-cart__count');
                        span.id = 'order-product';
                        span.innerText = http.response;
                        this.append(span);
                    }
                    

                } else {
                    this.btn_cart.querySelector('.header__min-cart__count').remove();
                }
            }
        };
        http.send(params);
    }

    converObc(obc) {
        let html = '';
        for (let [key, value] of Object.entries(obc)) {
            if (typeof value === 'object') {
                let name = [];
                for (let [key1, value2] of Object.entries(value)) {
                    name.push(value2);
                }
                html += `${key}=${name}&`
            } else {
                html += `${key}=${value}&`
            }
        }
        return html.substring(0, html.length - 1);
    };


    showNav(el){
        el.addEventListener('click', e => {
            e.preventDefault();
            el.classList.toggle('active');
            this.glob.slideToggle(this.header.querySelector('.header__menu'));
        })
    }

    boxInformation(el){
        el.querySelector('.close').addEventListener('click', () => {
            this.fadeOut(el);
            this.setCookie('accept_information', 'yes', 1);
        })
    }

    showSearch(el){
        el.addEventListener('click', () => {
            document.querySelector('.box__search').classList.add('active');
        })

        document.querySelector('.box__search .close').addEventListener('click', e => {
            e.preventDefault();
            document.querySelector('.box__search').classList.remove('active');
        });
    }

    showCart(el){
        el.addEventListener('click', () => {
            this.header.querySelector('.mini-cart').classList.toggle('active');
        });
        this.header.querySelector('.mini-cart .close').addEventListener('click', () => {
            this.header.querySelector('.mini-cart').classList.remove('active');
        });
    }
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    fadeOut(el) {
        el.style.opacity = 1;
        (function fade() {
            if ((el.style.opacity -= .1) <= 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    };
}

export default Header;